import React, { useContext, useEffect } from 'react';
import Main from './components/router/Main';
import Footer from './components/dashboard/Footer';
import Header from './components/dashboard/Header';
import Accessibility from './components/dashboard/Accessibility';
import { AccessibilityContext } from './contexts/AccessibilityContext';
import './App.css';

require('dotenv').config();

function App() {
  const { fontSize, contrasteActivo } = useContext(AccessibilityContext);

  useEffect(() => {
    document.documentElement.style.setProperty('--global-base-font-size', `${fontSize}px`);


    if (contrasteActivo) {
      document.documentElement.classList.add('set-contrast');
    } else {
      document.documentElement.classList.remove('set-contrast');
    }
  }, [fontSize, contrasteActivo]);

  return (
    <div className="App">
      <Header />
      <Accessibility></Accessibility>
      <main
        id="js-page-content"
        role="main"
        className="page-content mb-5"
        style={{ flex: '1' }}
      >
        <noscript>You need to enable JavaScript to run this app.</noscript>
        <Main />
      </main>
      <Footer />
      
      <div
        className="page-content-overlay"
        data-action="toggle"
        data-class="mobile-nav-on"
      >
        {' '}
      </div>
    </div>
  );
}
export default App;
